import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Pin } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchPinnedMessages, GROUP_OPS_STR as S, type PinnedMessageRow } from './groupOpsApi'

/**
 * A4.15 — Pinned/muhim xabarlar. REAL: `/admin/group-ops/pinned` —
 * pinned_messages ⨝ messages ⨝ dialogs (guruh/kanal mahkamlangan xabarlari).
 */
export function GroupPinnedMessages() {
  const columns = useMemo<AdminColumn<PinnedMessageRow>[]>(
    () => [
      {
        key: 'group_title',
        header: S.chat,
        type: 'text',
        width: 200,
        render: (r) => (
          <Link to={`/groups/${r.group_id}`} className="text-accent hover:underline">
            {r.group_title || `#${r.group_id}`}
          </Link>
        ),
      },
      { key: 'sender', header: S.sender, type: 'text', width: 150 },
      { key: 'text', header: S.message, type: 'longtext', minWidth: 240 },
      { key: 'pinned_at', header: S.pinnedAt, type: 'date', width: 160 },
    ],
    [],
  )
  const fetcher = useCallback(fetchPinnedMessages, [])
  return (
    <>
      <PageHeader title={S.pinnedMessages} screenId="A4.15" description={S.pinnedNote} />
      <DataTable<PinnedMessageRow>
        screenId="A4.15"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Pin size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
